import * as jsxRuntime from "/codebuild/output/src3370156738/src/super-admin-frontend/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment